import React from "react";
import $ from "jquery";

import "./_apps.scss";

import { icon } from "../icons/Icons";

export const popupApps = (height, width, name) => {
    $(".btn-apps").css({ height: height, width: width });
    $(".popup-apps").css({ animation: `0.3s ${name} both` });
};

const links = {
    google: [
        {
            name: "My Account",
            link: "https://myaccount.google.com/",
            icon: "myAccount",
        },
        {
            name: "Gmail",
            link: "https://mail.google.com/",
            icon: "gmail",
        },
        {
            name: "Youtube",
            link: "https://www.youtube.com/",
            icon: "youtube",
        },
        {
            name: "Drive",
            link: "https://drive.google.com/",
            icon: "drive",
        },
        {
            name: "Maps",
            link: "https://www.google.com/maps/",
            icon: "maps",
        },
        {
            name: "Translate",
            link: "https://translate.google.com/",
            icon: "translate",
        },
    ],
    others: [
        {
            name: "Instagram",
            link: "https://www.instagram.com/",
            icon: "instagram",
        },
        {
            name: "Tik Tok",
            link: "https://www.tiktok.com/",
            icon: "tiktok",
        },
        {
            name: "Twitch",
            link: "https://www.twitch.tv/",
            icon: "twitch",
        },
        {
            name: "Twitter",
            link: "https://twitter.com/",
            icon: "twitter",
        },
        {
            name: "GitHub",
            link: "https://github.com/",
            icon: "github",
        },
        {
            name: "Reddit",
            link: "https://www.reddit.com/",
            icon: "reddit",
        },
        {
            name: "Amazon",
            link: "https://www.amazon.com/",
            icon: "amazon",
        },
    ],
};

function PopupApps(props) {

    return (
        <div className="popup-apps" style={{ backgroundColor: props.background, boxShadow: "0 0 3px " + props.shadow }}>
            <ul>
                {links.google.map((index, key) => {
                    return (
                        <a href={index.link} key={key} style={{ color: props.text }}>
                            <li>
                                <img src={icon[index.icon]} alt={index.icon} width="20" />
                                {index.name}
                            </li>
                        </a>
                    );
                })}
                <div className="line-separator"></div>
                {links.others.map((index, key) => {
                    return (
                        <a href={index.link} key={key} style={{ color: props.text }}>
                            <li>
                                <img src={icon[index.icon]} alt={index.icon} width="20" />
                                {index.name}
                            </li>
                        </a>
                    );
                })}
            </ul>
        </div>
    );
}

export default PopupApps;
